/* global __MANIFEST_PLUGIN_HAS_LOCALISATION__ */
import { withPrefix } from "gatsby";
import getManifestForPathname from "./get-manifest-pathname"; // when we don't have localisation in our manifest, we tree shake everything away

export var onRouteUpdate = function onRouteUpdate(_ref, pluginOptions) {
  var location = _ref.location;

  if (__MANIFEST_PLUGIN_HAS_LOCALISATION__) {
    var localize = pluginOptions.localize;
    var manifestFilename = getManifestForPathname(location.pathname, localize, true);
    var manifestEl = document.head.querySelector("link[rel=\"manifest\"]");

    if (manifestEl) {
      manifestEl.setAttribute("href", withPrefix(manifestFilename));
    }
  }
};